module.exports = __webpack_public_path__ + "img/london-spirits-2022.565ad0b8.png";